<template>
  <section class="a-date" aria-labelledby="adjudicacion-date-title">
    <div class="a-date__card">
      <div class="a-date__illustration"><img :src="handsIcon" alt="" aria-hidden="true"></div>

      <div class="a-date__text">
        <h2 id="adjudicacion-date-title" class="a-date__title">¿Cuándo ocurre <br class="br-m">tu adjudicación?</h2>
        <p class="wd-body">
          Los contratos
          <span class="only-d">adjudicatarios</span><span class="only-t">adjudicados</span><span class="only-m">adjudicatarios</span>
          se determinan el <strong>tercer viernes hábil de cada mes.</strong>
        </p>
      </div>

      <div class="a-date__contact">
        <p class="a-date__label">Te Notificamos por</p>
        <p v-for="channel in channels" :key="channel.label" class="a-date__channel wd-body">
          <img :src="channel.icon" alt="" aria-hidden="true">
          <span>{{ channel.label }}</span>
        </p>
      </div>
    </div>

    <img class="a-date__image" :src="dateImage" alt="Pareja conversando sobre su nuevo hogar">
  </section>
</template>

<script setup lang="ts">
import handsIcon from '../../../assets/adjudicacion-figma/dashboard-hands.svg'
import dateImage from '../../../assets/adjudicacion-figma/fecha.jpg'
import mailIcon from '../../../assets/adjudicacion-figma/ic-mail.svg'
import callIcon from '../../../assets/adjudicacion-figma/ic-call.svg'
import storiesIcon from '../../../assets/adjudicacion-figma/ic-stories.svg'

const channels = [
  { icon: mailIcon, label: 'Correo electrónico' },
  { icon: callIcon, label: 'Llamada' },
  { icon: storiesIcon, label: 'Publicación oficial' }
]
</script>

<style scoped>
.a-date { display: flex; align-items: stretch; gap: var(--ds-space-5); }

.a-date__card {
  display: flex;
  flex: 0 0 387px;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 24px;
}

/* Ilustración de 72px: icono de 56×48 con padding 12 8 */
.a-date__illustration { display: flex; align-items: center; justify-content: center; width: 72px; height: 72px; }
.a-date__illustration img { width: 56px; height: 48px; }

.a-date__text { display: flex; flex-direction: column; gap: var(--ds-space-4); }
.a-date__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}
.a-date__text strong { font-weight: 600; }

.a-date__contact { display: flex; flex-direction: column; gap: var(--ds-space-4); }
.a-date__label {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin: 0;
  color: var(--ds-purple-900);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.a-date__channel { display: flex; align-items: center; gap: var(--ds-space-3); }
.a-date__channel img { flex: 0 0 24px; width: 24px; height: 24px; }

.a-date__image {
  flex: 1 1 0;
  min-width: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 24px;
}

@media (max-width: 1024px) {
  .a-date { flex-direction: column; gap: var(--ds-space-6); }
  .a-date__card { flex: none; }
  .a-date__image { flex: none; height: 430px; }
}
</style>
